import {Form, message} from 'antd';
import axios from 'axios';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {useHistory, useRouteMatch} from 'react-router';
import ActionBar from '../../../../components/action-bar';
import ActionButton from '../../../../components/action-button';
import useDispatchWithResult from '../../../../hooks/useDispatchWithResult';
import useLoading from '../../../../hooks/useLoading';
import {beneficiariosSocioelector, fetchBeneficiarioSocio, fetchBeneficiariosSocio} from '../../../../store/empresa';
import {valuesToFormData} from '../../../../util/formData';
import unwrapAxiosPromise from '../../../../util/unwrapAxiosPromise';
import EmpresaBeneficiarioSocioForm from './_form';
import useModulo from "../../../../hooks/useModulo";

export default function EmpresaBeneficiarioSocioEditPage() {
  const {t} = useTranslation();
  const dispatch = useDispatchWithResult();
  const [form] = Form.useForm();
  const beneficiarioSocio = useSelector(beneficiariosSocioelector);
  const loading = useLoading(fetchBeneficiarioSocio.typePrefix);
  const [loadingSave, setLoadingSave] = useState(false);
  const history = useHistory();
  const match = useRouteMatch();
  const empresaId = match.params.empresaId;
  const id = match.params.id;
  const {moduloBasePath} = useModulo();

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(beneficiarioSocio);
    setImmediate(() => document.querySelector('#socioId').focus());
  }, [beneficiarioSocio]);

  const handleFinish = values => {
    setLoadingSave(true);
    const formData = valuesToFormData(values);
    unwrapAxiosPromise(axios.put(`/empresas/${empresaId}/beneficiarios-socio/${id}`, formData), form)
        .then(() => {
          message.success(t('Registro alterado com sucesso'));
          history.replace(`${moduloBasePath}/empresas/${empresaId}/beneficiarios-socio/${id}`);
          dispatch(fetchBeneficiariosSocio({empresaId}));
          dispatch(fetchBeneficiarioSocio({empresaId, id}));
        })
        .finally(() => setLoadingSave(false));
  };

  const handleCancel = () => {
    history.replace(`${moduloBasePath}/empresas/${empresaId}/beneficiarios-socio/${id}`);
  };

  const title = (
      <ActionBar>
        <ActionButton.Save onClick={form.submit} loading={loadingSave} />
        <ActionButton.Cancel onClick={handleCancel} disabled={loadingSave} />
      </ActionBar>);

  return (
      <EmpresaBeneficiarioSocioForm
          disabled={loadingSave}
          empresaId={empresaId}
          form={form}
          loading={loading}
          onFinish={handleFinish}
          title={title}
      />);
}
